<script lang="ts">
	import Artist from './Artist.svelte';

	export let startAt: number;

	interface ArtistDetails {
		name: string;
		ytmCode: string;
	}

	export let artists: ArtistDetails[];
</script>

<div>
	{#each artists as a, index}
		<Artist number={startAt + index} name={a.name} ytmCode={a.ytmCode} />
	{/each}
</div>

<style>
	div {
		margin-top: 3.5rem;
		margin-bottom: 1rem;
	}
</style>
